/*
 * Constants
 ***************************/
var $ = jQuery.noConflict();
const mobileBreakpoint = 767;
const windowResizeActions = [];
let scrollTop = $(window).scrollTop(),
  navTrigger = 0;

/*
 * Viewport height adjustments
 ***************************/
// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
let vh = window.innerHeight * 0.01;
// Then we set the value in the --vh custom property to the root of the document
document.documentElement.style.setProperty("--vh", `${vh}px`);
window.addEventListener("resize", () => {
  // We execute the same script as before
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", `${vh}px`);
});

/*
 * Globals
 ***************************/
/* Window */
var windowWidth = $(window).width();
var windowHeight = $(window).height();
var windowScrollHeight = document.querySelector("body").scrollHeight;
/* Breakpoints */
var isMobile = windowWidth <= mobileBreakpoint;
/* Navigation */
var isMenuOpen = false,
  isTakeoverMenuOpen = false,
  isSearchOpen = false;

/* Ajax */
let currentPage = 1;
let ajaxIsLoading = false;
let isDoneLoadingThings = false;
let currentUrl = window.location.href;

/* Slick Options */
const prevArrow =
  '<button type="button" class="slick-big-arrow slick-prev"><span class="screen-reader-text">Previous</span></button>';
const nextArrow =
  '<button type="button" class="slick-big-arrow slick-next"><span class="screen-reader-text">Next</span></button>';

const handleKeypressADA = function () {
  const keycode = event.keyCode ? event.keyCode : event.which;
  if (keycode == "13") return;
  $(this).trigger("click");
};

$(window).on("load", function () {
  windowWidth = $(window).width();
  windowHeight = $(window).height();
  windowScrollHeight = document.querySelector("body").scrollHeight;
});

$(document).ready(function () {
  const motionQuery = window.matchMedia("(prefers-reduced-motion: reduce)");

  gsap.registerPlugin(ScrollTrigger, Flip);

  /* Generic */
  if ($(".modal-area").length) {
    $(".modal-area").each(function () {
      const prop = $(this).data("propid");

      $(this)
        .find(".modal-area__dismiss")
        .on("click", function () {
          $(this).closest(".modal-area").removeClass("active");
          window.localStorage.setItem(prop, "true");
        })
        .on("keypress", handleKeypressADA);

      const element = $(this).get(0);

      $(this).on("click", function (e) {
        if (e.target !== element && !element.contains(e.target)) {
          $(this).removeClass("active");
          window.localStorage.setItem(prop, "true");
        }
      });

      const modalDismissed = window.localStorage.getItem(prop);
      if (modalDismissed != "true") {
        const modal = $(this);
        setTimeout(function () {
          modal.addClass("active");
        }, $(this).data("delay"));
      }
    });
  }

  if ($(".smooth-scroller").length) {
    // internal links, smooth scrolling
    $(".smooth-scroller")
      .on("click", function (e) {
        e.preventDefault();
        let target = $($(this).attr("href")).offset().top - 148;
        let dist = Math.abs($(window).scrollTop() - target);

        $([document.documentElement, document.body]).animate(
          {
            scrollTop: target,
          },
          Math.min(1200, (dist / 1200) * 1000)
        );
      })
      .on("keypress", handleKeypressADA);
  }

  if ($(".copybutton").length) {
    $(".copybutton")
      .on("click", function (e) {
        e.preventDefault();
        const targetEl = $($(this).data("target")).get(0);
        const alertEl = $($(this).data("alert")).get(0);
        targetEl.select();
        targetEl.setSelectionRange(0, 9999999);
        document.execCommand("copy");
        $(alertEl).fadeIn();
        setTimeout(function () {
          $(alertEl).fadeOut();
        }, 6000);
      })
      .on("keypress", handleKeypressADA);
  }

  if ($(".modaltrigger").length) {
    $(".modaltrigger")
      .on("click", function (e) {
        e.preventDefault();
        $(this).addClass("active");
        $(this).attr("aria-expanded", true);
        $($(this).attr("href")).addClass("active");
        $("#masthead").removeClass("scrolled-back");
        $("#masthead").addClass("scrolled");
        $("body").addClass("no-scroll");
      })
      .on("keypress", handleKeypressADA);
  }

  if ($(".modalclose").length) {
    $(".modalclose")
      .on("click", function (e) {
        e.preventDefault();
        const controlledBy = $(this).data("controlledby");
        $(this).closest(".modal").removeClass("active");
        $(controlledBy).removeClass("active");
        $(controlledBy).attr("aria-expanded", false);
        $("body").removeClass("no-scroll");
      })
      .on("keypress", handleKeypressADA);
  }

  if ($(".site-searchform").length) {
    $(".site-searchform").each(function () {
      const input = $(this).find(".site-searchform__input");
      const submit = $(this).find(".site-searchform__submit");

      submit.on("click", function (e) {
        if ($(input).val() == "") {
          e.preventDefault();
          $(input).focus();
        }
      });
    });
  }
  /* END GENERIC SCRIPTS */

  /* NAVIGATION SCRIPTS */
  if ($(".site-header__nav").length) {
    $(".site-header__outer").removeClass("no-js");

    // Mobile - from header -> sticky bottom
    var header = $(".site-header__iykyk");
    var footer = $("footer");

    if (header.length && footer.length && isMobile) {
      footer.after(header);
    }

    if ($(".site-header__iykyk").length) {
      let adHeight = $(".site-header__iykyk").outerHeight();
      let totalHeight = !isMobile
        ? adHeight + $(".site-header").outerHeight()
        : $(".site-header").outerHeight();
      document.documentElement.style.setProperty(
        "--nav-height",
        `${totalHeight}px`
      );

      $(window).on("resize", function () {
        adHeight = $(".site-header__iykyk").outerHeight();
        totalHeight = !isMobile
          ? adHeight + $(".site-header").outerHeight()
          : $(".site-header").outerHeight();
        document.documentElement.style.setProperty(
          "--nav-height",
          `${totalHeight}px`
        );
      });

      $(".site-header__nav-inner").addClass("has-iykyk");

      ScrollTrigger.matchMedia({
        "(min-width:768px)": function () {
          gsap.to(".site-header__outer-inner", {
            y: () => {
              return "-=" + adHeight;
            },
            ease: "linear",
            scrollTrigger: {
              trigger: "body",
              start: "top top",
              end: () => {
                return "top top-=" + adHeight;
              },
              scrub: true,
              onLeave: () => {
                $(".site-header__nav-inner").addClass("iykyk-hidden");
              },
              onEnterBack: () => {
                $(".site-header__nav-inner").removeClass("iykyk-hidden");
              },
            },
          });
        },
      });

      if (window.hasOwnProperty("check_for_ads_in_page")) {
        window.check_for_ads_in_page(true);
      }

      // const navResizeAction = (updated) => {
      //   if ( updated ) {
      //     if ( isMobile ) {
      //       header.detach();
      //       footer.after(header);
      //     } else {
      //       // header.
      //     }
      //   }
      // };

      // navResizeAction(true);
      // windowResizeActions.push(navResizeAction);
    }

    const navResizeAction = (updated) => {
      if (updated) {
        if (isMobile) {
          $("#site-nav").attr("role", "dialog");
          $("#site-nav").attr("aria-modal", "true");
          console.log("Window resized. Add ad to footer");
          footer.after(header);
        } else {
          const navEl = $("#site-nav").get(0);
          navEl.removeAttribute("role");
          navEl.removeAttribute("aria-modal");
        }
      }
    };

    navResizeAction(true);
    windowResizeActions.push(navResizeAction);

    const mobileNavContainer = $(".site-header__nav-inner");
    const mobileToggle = $(".site-header__nav-toggle");
    const mobileDismiss = $(".site-header__nav-dismiss");
    const firstFocusableMenuElement = $(mobileNavContainer)
      .find("a, button, input")
      .eq(0)
      .get(0);
    const lastFocusableMenuElement = mobileDismiss.get(0);

    if ($(mobileNavContainer).find(".menu-item-has-children")) {
      $(mobileNavContainer)
        .find(".menu-item-has-children")
        .each(function () {
          const toggle = $(this).children("a, button");
          const submenu = $(this).children(".sub-menu");

          let target = $(toggle).attr("aria-controls");
          let expanded = $(toggle).attr("aria-expanded");

          const toggleResizeAction = (updated) => {
            if (updated) {
              if (isMobile) {
                $(toggle).attr("aria-controls", target);
                $(toggle).attr("aria-expanded", expanded);
              } else {
                $(toggle).get(0).removeAttribute("aria-controls");
                $(toggle).get(0).removeAttribute("aria-expanded");
              }
            }
          };
          toggleResizeAction(true);

          toggle
            .on("click", function () {
              if (isMobile) {
                expanded = expanded == "true" ? "false" : "true";
                $(toggle).attr("aria-expanded", expanded);
                console.log(submenu);
                submenu.slideToggle();
              }
            })
            .on("keypress", handleKeypressADA);
        });
    }

    $(".site-header__nav-toggle")
      .on("click", function () {
        $(this).toggleClass("active");
        if ($(this).hasClass("active")) {
          $(mobileNavContainer).css({
            visibility: "visible",
            "pointer-events": "auto",
          });
          gsap.to(mobileNavContainer, {
            duration: 0.8,
            ease: "power3.inOut",
            clipPath: "polygon(0 0, 100% 0, 100% 100%, 0% 100%)",
            onComplete: function () {
              $(mobileNavContainer).focus();
            },
          });
        } else {
          gsap.to(mobileNavContainer, {
            duration: 0.8,
            ease: "power3.inOut",
            clipPath: "polygon(0 0, 100% 0, 100% 0%, 0% 0%)",
            onComplete: function () {
              $(".site-header__nav-inner").css({
                visibility: "hidden",
                "pointer-events": "none",
              });
            },
          });
        }
      })
      .on("keypress", handleKeypressADA);

    $(mobileDismiss)
      .on("click", function () {
        if (isMobile) {
          gsap.to(mobileNavContainer, {
            duration: 0.8,
            ease: "power3.inOut",
            clipPath: "polygon(0 0, 100% 0, 100% 0%, 0% 0%)",
            onComplete: function () {
              $(".site-header__nav-inner").css({
                visibility: "hidden",
                "pointer-events": "none",
              });
            },
          });

          $(mobileToggle).removeClass("active");
          $(mobileToggle).focus();
        }
      })
      .on("keypress", handleKeypressADA);

    $(mobileNavContainer).on("keydown", function (e) {
      if (isMobile) {
        if (e.key == "Escape") {
          mobileDismiss.click();
        } else if (
          e.target == firstFocusableMenuElement &&
          e.key == "Tab" &&
          e.shiftKey
        ) {
          e.preventDefault();
          lastFocusableMenuElement.focus();
        } else if (
          e.target == lastFocusableMenuElement &&
          e.key == "Tab" &&
          !e.shiftKey
        ) {
          e.preventDefault();
          firstFocusableMenuElement.focus();
        }
      }
    });

    if ($(".sub-menu-toggle").length) {
      $(".sub-menu-toggle").each(function () {
        const target = $("#" + $(this).data("target"));
        const thisRef = this;

        $(target)
          .find(".site-header__nav-menu-dropdowns__modal-dismiss")
          .on("click", function () {
            $(thisRef).click();
          });

        $(window).on("click", function (e) {
          if ($(thisRef).hasClass("active") && !isMobile) {
            if (
              e.target !== thisRef &&
              !thisRef.contains(e.target) &&
              e.target !== target.get(0) &&
              !target.get(0).contains(e.target)
            ) {
              $(thisRef).click();
            }
          }
        });

        $(this).on("click", function () {
          if (!isMobile) {
            if ($(this).hasClass("active")) {
              $(this).removeClass("active");
              const closeAnim = gsap.timeline({
                paused: true,
                repeat: false,
                onComplete: function () {
                  $(target)
                    .css({
                      visibility: "hidden",
                      "pointer-events": "none",
                    })
                    .removeClass("active");
                },
              });

              closeAnim.to(target, {
                duration: 0.8,
                ease: "power3.inOut",
                clipPath: "polygon(0 0, 100% 0, 100% 0%, 0% 0%)",
              });

              closeAnim.play();
            } else {
              $(this).addClass("active");
              const openModal = $(
                ".site-header__nav-menu-dropdowns__modal.active"
              );

              const openAnim = gsap.timeline({
                paused: true,
                repeat: false,
                onStart: function () {
                  $(target)
                    .css({
                      visibility: "visible",
                      "pointer-events": "auto",
                    })
                    .addClass("active");
                },
              });

              openAnim.to(target, {
                duration: 0.8,
                ease: "power3.inOut",
                clipPath: "polygon(0 0, 100% 0, 100% 100%, 0% 100%)",
              });

              if (openModal.length) {
                const closeAnim = gsap.timeline({
                  paused: true,
                  repeat: false,
                  onComplete: function () {
                    $(openModal)
                      .css({
                        visibility: "hidden",
                        "pointer-events": "none",
                      })
                      .removeClass("active");

                    openAnim.play();
                  },
                });

                closeAnim.to(openModal, {
                  duration: 0.8,
                  ease: "power3.inOut",
                  clipPath: "polygon(0 0, 100% 0, 100% 0%, 0% 0%)",
                });

                closeAnim.play();
              } else {
                openAnim.play();
              }
            }
          } else {
            const target = $("#" + $(this).data("target"));
            $(target).slideToggle();
            $(this).toggleClass("mobile-active");
          }
        });
      });
    }
  }
  /* END NAVIGATION SCRIPTS */

  /* GUTENBERG BLOCK SCRIPTS */
  if ($(".arky-hp-carousel").length) {
    $(".arky-hp-carousel").each(function () {
      const slides = $(this).find(".arky-hp-carousel__slides");
      const cards = $(this).find(".arky-hp-carousel__list .content-card");
      const list = $(this).find(".arky-hp-carousel__list-inner");
      const mobileList = $(this).find(
        ".arky-hp-carousel__list-inner-container"
      );

      $(cards).eq(0).addClass("active");

      slides.slick({
        fade: true,
        arrowsPlacement: "afterSlides",
        autoplay: true,
        autoplaySpeed: 6000,
      });

      slides.append(
        '<div class="arky-hp-carousel__nums"><span class="arky-hp-carousel__nums-cur">01</span> / <span>' +
          (cards.length + "").padStart(2, "0") +
          "</span></div>"
      );
      const cur = $(this).find(".arky-hp-carousel__nums-cur");

      $(this)
        .find(".arky-hp-carousel__nums, .slick-arrow")
        .wrapAll('<div class="arky-hp-carousel__slides-controls"></div>');

      slides.on(
        "beforeChange",
        function (event, slick, currentSlide, nextSlide) {
          $(cur).text((nextSlide + 1 + "").padStart(2, "0"));

          cards.removeClass("active");
          cards.eq(nextSlide).addClass("active");
        }
      );

      const toggle = $(this).find(".arky-hp-carousel__list-mobiletoggle");

      $(toggle).on("click", function () {
        $(this).toggleClass("active");
        if ($(this).hasClass("active")) {
          $(mobileList).css({
            "pointer-events": "auto",
            visibility: "visible",
          });

          gsap.to(mobileList, {
            opacity: 1,
            scale: 1,
            duration: 0.6,
            ease: "power3.inOut",
          });
        } else {
          gsap.to(mobileList, {
            opacity: 0,
            scale: 0.95,
            duration: 0.6,
            ease: "power3.inOut",
            onComplete: function () {
              $(mobileList).css({
                "pointer-events": "none",
                visibility: "hidden",
              });
            },
          });
        }
      });

      $(this)
        .find(".arky-hp-carousel__list-inner-container-dismiss")
        .on("click", function () {
          $(toggle).removeClass("active");
          gsap.to(mobileList, {
            opacity: 0,
            scale: 0.95,
            duration: 0.6,
            ease: "power3.inOut",
            onComplete: function () {
              $(mobileList).css({
                "pointer-events": "none",
                visibility: "hidden",
              });
            },
          });
        });
    });
  }

  // gallery
  // if ( $('.wp-block-gallery').length ) {
  //   $('.wp-block-gallery').each(function(){
  //     gutenbergSlickify(this);
  //   });
  // }

  //accordion
  if ($(".accordion-inner").length) {
    $(".accordion-inner").each(function () {
      const toggle = $(this).find(".accordion-inner__title button");
      const title = $(this).find(".accordion-inner__title");
      const content = $(this).find(".accordion-inner__content");

      if (!content.hasClass("open-on-load")) {
        content.hide();
      }

      toggle
        .on("click", function () {
          content.slideToggle();
          const expanded = $(this).attr("aria-expanded");
          $(this).attr("aria-expanded", expanded == "true" ? "false" : "true");
          title.toggleClass("expanded");
        })
        .on("keypress", handleKeypressADA);
    });
  }

  if ($(".single-article__container").length) {
    const progress = $(".single-article__container-progress__sticky-per");
    if (progress.length) {
      gsap.to(progress, {
        height: "100%",
        ease: "none",
        scrollTrigger: {
          trigger: ".single-article__container",
          start: "top top+=156",
          end: "bottom top+=156",
          scrub: true,
        },
      });
    }
  }

  if ($(".atw-map").length) {
    $(".atw-map").each(function () {
      const container = $(this);
      const ns = $(this).attr("id");
      const cards = $(this).find(".atw-map__sidebar-card");
      const modals = $(this).find(".atw-map__main-modals");

      $(cards).each(function () {
        const trigger = $(this).find(".atw-map__sidebar-card__trigger");
        const card = this;
        const modal = $(container).find("#" + trigger.data("controls"));
        const dismiss = $(modal).find(".atw-map__modal-dismiss");

        $(dismiss).on("click", function () {
          $(trigger).click();
        });

        $(trigger).on("click", function () {
          const thisRef = this;
          const animTL = gsap.timeline({
            paused: true,
            repeat: false,
          });

          if (!$(modal).hasClass("active")) {
            $(card).addClass("active");
            animTL.eventCallback("onStart", function () {
              $(modals).addClass("mobile-open");
              $("body").addClass("mobile-atw-open");
              modal.addClass("active").css({
                visibility: "visible",
                "pointer-events": "auto",
              });
            });

            const activeModal = $(container).find(".atw-map__modal.active");
            if (activeModal.length) {
              animTL.to(activeModal, {
                opacity: 0,
                duration: 0.4,
                onStart: function () {
                  $(
                    '.atw-map__sidebar-card__trigger[data-controls="' +
                      $(activeModal).attr("id") +
                      '"]'
                  )
                    .closest(".atw-map__sidebar-card")
                    .removeClass("active");
                },
                onComplete: function () {
                  activeModal
                    .css({
                      visibility: "hidden",
                      "pointer-events": "none",
                    })
                    .removeClass("active");
                },
              });
            }

            animTL.to(modal, {
              opacity: 1,
              duration: 0.4,
            });
          } else {
            $(card).removeClass("active");
            $(modals).removeClass("mobile-open");
            $("body").removeClass("mobile-atw-open");
            animTL.eventCallback("onComplete", function () {
              modal
                .css({
                  visibility: "hidden",
                  "pointer-events": "none",
                })
                .removeClass("active");
            });

            animTL.to(modal, {
              opacity: 0,
              duration: 0.4,
            });
          }

          animTL.play();
        });
      });

      const svg = d3.select("#" + ns + " .atw-map__main-map"),
        width = +svg.attr("width"),
        height = +svg.attr("height");

      const projection = d3
        .geoNaturalEarth1()
        .scale(width / 1.8 / Math.PI)
        .translate([width / 2, height / 2]);

      d3.json(archaeologyVars.worldGeoJSON).then(function (data) {
        // Draw the map
        svg
          .append("g")
          .selectAll("path")
          .data(data.features)
          .join("path")
          .attr("fill", "none")
          .attr("stroke", "#C6C6C6")
          .attr("stroke-width", "0.5")
          .attr("vector-effect", "non-scaling-stroke")
          .attr("d", d3.geoPath().projection(projection));

        const pointsG = svg.append("g");
        const collection = {
          type: "FeatureCollection",
          features: [],
        };

        $(cards).each(function () {
          if (this.hasAttribute("data-location")) {
            console.log($(this).data("location"));
            collection.features.push($(this).data("location"));
          }
        });

        console.log(collection);

        svg
          .append("g")
          .selectAll("path")
          .data(collection.features)
          .enter()
          .append("path")
          .attr(
            "d",
            "M4.57334 12.1559C4.40323 12.7254 3.59677 12.7254 3.42666 12.1559L0.0254246 0.769745C-0.0892165 0.385967 0.198232 0.00010426 0.598767 0.000104278L7.40124 0.000104575C7.80177 0.000104593 8.08922 0.385969 7.97458 0.769748L4.57334 12.1559Z"
          )
          .attr("fill", "#4189EB")
          .attr("stroke", "none")
          .attr("transform", function (d) {
            return (
              "translate(" +
              (projection(d.geometry.coordinates)[0] - 4) +
              " " +
              (projection(d.geometry.coordinates)[1] - 12) +
              ")"
            );
          });
      });
    });
  }

  if ($(".article-inner").length) {
    $(".article-inner").each(function () {
      const thisRef = $(this);
      const content = $(this).find(".article-inner__content");

      $(this)
        .find(".article-inner__title button")
        .on("click", function () {
          var $icon = $(this)
            .closest(".article-inner__title")
            .find(".upper-title svg");
          var $identifier = $(this)
            .closest(".article-inner__title")
            .find(".upper-title h6");
          var isExpanded = $(this).attr("aria-expanded") === "true";

          $(this).attr("aria-expanded", isExpanded ? "false" : "true");

          if (isExpanded) {
            $identifier.html("EXPAND");
            $icon.html(
              '<svg id="article-expand" width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.57334 12.1559C4.40323 12.7254 3.59677 12.7254 3.42666 12.1559L0.0254245 0.769745C-0.0892167 0.385967 0.198232 0.000104563 0.598767 0.000104581L7.40123 0.000104878C7.80177 0.000104896 8.08922 0.385969 7.97458 0.769748L4.57334 12.1559Z" fill="#4189EB"/></svg>'
            );

            $(thisRef).css("overflow", "hidden");
            gsap.to(thisRef, {
              height: isMobile ? 210 : 282,
              duration: 0.6,
              ease: "power3.inOut",
              onComplete: function () {
                $(content).addClass("hide-before");
              },
            });
          } else {
            $identifier.html("COLLAPSE");
            $icon.html(
              '<svg id="article-collapse" width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.57334 0.427108C4.40323 -0.142371 3.59677 -0.142368 3.42666 0.42711L0.0254245 11.8133C-0.0892167 12.197 0.198232 12.5829 0.598767 12.5829L7.40123 12.5829C7.80177 12.5829 8.08922 12.197 7.97458 11.8133L4.57334 0.427108Z" fill="#4189EB"/></svg>'
            );

            $(content).removeClass("hide-before");
            gsap.to(thisRef, {
              height: "auto",
              duration: 0.6,
              ease: "power3.inOut",
              onComplete: function () {
                $(thisRef).css("overflow", "auto");
              },
            });
          }
        });
    });
  }

  /* PAYWALL SCRIPTS */
  if ($(".paywall-violator.fixed.active").length) {
    $("body").addClass("no-scroll");
  } else if ($(".paywall-violator.inline").length) {
    ScrollTrigger.create({
      trigger: ".paywall-violator__inline-trigger",
      start: "bottom bottom",
      endTrigger: "body",
      end: "bottom top",
      onEnter: function () {
        $("body").addClass("no-scroll");

        gsap.set(".paywall-violator", {
          opacity: 0,
          y: "100%",
        });

        $(".paywall-violator").css({
          visibility: "visible",
          "pointer-events": "auto",
        });

        gsap.to(".paywall-violator", {
          opacity: 1,
          y: 0,
          duration: 0.6,
        });
      },
    });
  }
  /* END GUTENBERG SCRIPTS */

  /* ARCHIVE BLOCK SCRIPTS */
  if ($(".archive-block").length) {
    $(".archive-block").each(function () {
      if ($(this).hasClass("dont-script")) {
        return;
      }
      const archiveBlock = $(this);
      const archiveFeed = $(this).find(".archive-block__feed");
      const archivePagination = $(this).find(
        ".archive-block__pagination-container"
      );

      const archiveFilterForm = $(this).find(".archive-block__header");
      const archiveSortInputs = $(this).find(
        ".archive-block__sort-radio-input"
      );
      const archiveSearchInput = $(this).find(".archive-block__search-input");
      const archiveSearchConfirm = $(this).find(
        ".archive-block__search-confirm"
      );

      const archiveFilterGroups = $(this).find(".archive-block__filter");

      const base = $(this).data("baseurl");
      let currentURL = $(this).data("currenturl");
      const initPage = $(this).data("page");
      const postType = $(this).data("posttype");
      const exclude = $(this).data("exclude");

      let updateArchive;
      let stateObj = {
        base: base,
        url: currentURL,
        page: initPage,
        sort: "default",
        postType: postType,
        search: false,
        exclude: exclude,
        taxonomy: false,
        term: false,
        filters: {},
      };

      if (this.hasAttribute("data-postsper")) {
        stateObj.postsPerPage = $(this).data("postsper");
      }

      if (this.hasAttribute("data-cardargs")) {
        stateObj.cardArgs = $(this).data("cardargs");
      }

      if (this.hasAttribute("data-taxonomy")) {
        stateObj.taxonomy = $(this).data("taxonomy");
      }

      if (this.hasAttribute("data-term")) {
        stateObj.term = $(this).data("term");
      }

      const updateURLFromFilters = () => {
        const baseurl =
          base[0] === "/" ? window.location.protocol + base : base;
        const url = new URL(baseurl);
        if (stateObj.sort !== "default") {
          url.searchParams.append("sort", "sort-" + stateObj.sort);
        }

        if (stateObj.search !== false) {
          url.searchParams.append("search", stateObj.search);
        }

        if (Object.keys(stateObj.filters).length) {
          for (const filterType in stateObj.filters) {
            if (Array.isArray(stateObj.filters[filterType])) {
              url.searchParams.append(
                filterType,
                stateObj.filters[filterType].join(",")
              );
            } else {
              url.searchParams.append(filterType, stateObj.filters[filterType]);
            }
          }
        }

        stateObj.url = url.toString();
        stateObj.page = 1;

        updateArchive();
      };

      if (archiveFilterGroups.length) {
        $(archiveFilterGroups).each(function () {
          const inputs = $(this).find("input");
          const indicator = document.createElement("span");
          indicator.classList.add(
            "archive-block__filter-input__label-indicator"
          );

          const mobileToggle = $(this).find(".archive-block__filter-toggle");
          const mobileDropdown = $(this).find(".archive-block__filter-list");

          mobileToggle
            .on("click", function () {
              if (true) {
                // set to isMobile to make responsive
                $(this).attr(
                  "aria-expanded",
                  $(this).attr("aria-expanded") == "true" ? "false" : "true"
                );

                if ($(this).attr("aria-expanded") == "true") {
                  $(mobileDropdown).css({
                    visibility: "visible",
                    "pointer-events": "auto",
                  });
                  gsap.to(mobileDropdown, {
                    clipPath: "polygon(0 0, 100% 0, 100% 100%, 0% 100%)",
                  });
                } else {
                  gsap.to(mobileDropdown, {
                    clipPath: "polygon(0 0, 100% 0, 100% 0%, 0% 0%)",
                    onComplete: function () {
                      $(mobileDropdown).css({
                        visibility: "hidden",
                        "pointer-events": "none",
                      });
                    },
                  });
                }
              }
            })
            .on("keypress", handleKeypressADA);

          $(inputs).each(function () {
            const name = $(this).attr("name");
            const type = $(this).attr("type");
            const val = $(this).attr("value");

            if ($(this).is(":checked")) {
              const label = $(this)
                .siblings(".archive-block__filter-input__label")
                .get(0);
              label.appendChild(indicator);

              if (type === "radio") {
                stateObj.filters[name] = val;
              } else {
                if (stateObj.filters.hasOwnProperty(name)) {
                  stateObj.filters[name].push(val);
                } else {
                  stateObj.filters[name] = [val];
                }
              }
            }

            $(this).on("change", function () {
              if ($(this).is(":checked")) {
                const state = Flip.getState(indicator);
                const label = $(this)
                  .siblings(".archive-block__filter-input__label")
                  .get(0);
                label.appendChild(indicator);
                Flip.from(state, {
                  absolute: true,
                  duration: 0.6,
                  ease: "back.inOut",
                });

                $(mobileToggle)
                  .find(".archive-block__filter-toggle__current")
                  .text(label.textContent);

                if (type === "radio") {
                  stateObj.filters[name] = val;
                } else {
                  stateObj.filters[name].push(val);
                }
              } else if (type === "checkbox") {
                stateObj.filters[name] = stateObj.filters[name].filter(
                  (e) => e !== val
                );
              }
              updateURLFromFilters();

              if (true) {
                // change to isMobile to make responsive
                $(mobileToggle).attr("aria-expanded", "false");
                gsap.to(mobileDropdown, {
                  clipPath: "polygon(0 0, 100% 0, 100% 0%, 0% 0%)",
                  onComplete: function () {
                    $(mobileDropdown).css({
                      visibility: "hidden",
                      "pointer-events": "none",
                    });
                  },
                });
              }
            });
          });
        });
      }

      if (archiveSortInputs.length) {
        const toggle = $(this).find(".archive-block__sort-toggle");
        const dropdown = $(this).find(".archive-block__sort-dropdown");
        const toggleHint = $(toggle).find(
          ".archive-block__sort-toggle__current"
        );

        const toggleDropdown = (state) => {
          if (state) {
            $(dropdown).css({
              visibility: "visible",
              "pointer-events": "auto",
            });

            gsap.to(dropdown, {
              clipPath: "polygon(0 0, 100% 0, 100% 100%, 0% 100%)",
            });
          } else {
            gsap.to(dropdown, {
              clipPath: "polygon(0 0, 100% 0, 100% 0%, 0% 0%)",
              onComplete: function () {
                $(dropdown).css({
                  visibility: "hidden",
                  "pointer-events": "none",
                });
              },
            });
          }
        };

        $(toggle)
          .on("click", function () {
            const oldState = $(this).attr("aria-expanded") == "true";
            $(this).attr("aria-expanded", oldState ? "false" : "true");
            toggleDropdown(!oldState);
          })
          .on("keypress", handleKeypressADA);

        if ($(".archive-block__sort-radio-input:checked").length) {
          stateObj.sort = $(".archive-block__sort-radio-input:checked").data(
            "sortkey"
          );
        }

        $(archiveSortInputs).on("change", function () {
          stateObj.sort = $(".archive-block__sort-radio-input:checked").data(
            "sortkey"
          );
          $(toggle).attr("aria-expanded", "false");
          toggleDropdown(false);
          updateURLFromFilters();
          $(toggleHint).text($(this).next().text());
        });
      }

      if (archiveSearchInput.length) {
        if (archiveSearchInput.val() !== "") {
          stateObj.search = archiveSearchInput.val();
        }
      }

      if (archiveSearchConfirm.length) {
        archiveSearchConfirm
          .on("click", function () {
            const searchQuery = archiveSearchInput.val();
            if (searchQuery !== "") {
              if (stateObj.search !== searchQuery) {
                stateObj.search = searchQuery;
              }

              updateURLFromFilters();
            } else {
              if (stateObj.search !== false) {
                stateObj.search = false;
                updateURLFromFilters();
              }
            }
          })
          .on("keypress", handleKeypressADA);
      }

      if (archiveFilterForm.length) {
        archiveFilterForm.on("submit", function (e) {
          e.preventDefault();
          if (archiveSearchConfirm.length) {
            archiveSearchConfirm.trigger("click");
          }
        });
      }

      $(archivePagination)
        .on("click", "a", function (e) {
          e.preventDefault();
          if (ajaxIsLoading === false) {
            const url = $(e.target).attr("href");
            let page = 1;
            const urlparts = url.split("?")[0].split("/");
            let parsedNum = false;
            for (let i = urlparts.length - 1; i >= 0; i--) {
              if (urlparts[i] != "") {
                const parsed = parseInt(urlparts[i]);
                if (!isNaN(parsed)) {
                  parsedNum = parsed;
                  break;
                }
              }
            }

            if (parsedNum !== false) {
              page = parsedNum;
            }

            console.log(page);

            stateObj.url = url;
            stateObj.page = page;

            updateArchive();
          }
        })
        .on("keypress", "a", function (e) {
          e.preventDefault();
          $(this).trigger("click");
        });

      const initState = stateObj;

      window.addEventListener("popstate", function (event) {
        if (Object.keys(event.state).length == 0) {
          stateObj = initState;
        } else {
          stateObj = event.state;
        }

        updateArchive(true);
      });

      const predecessorAd = $(this).prev(".ad-block-container");

      updateArchive = (frompopstate = false) => {
        ajaxIsLoading = true;
        $(archiveBlock).addClass("loading");
        gsap.to(window, {
          scrollTo: {
            y: predecessorAd.length
              ? predecessorAd.get(0)
              : archiveBlock.get(0),
            offsetY: isMobile ? 72 : 200,
          },
          duration: 0.8,
          ease: "power1.inOut",
        });

        if (frompopstate === false) {
          history.pushState(stateObj, "", stateObj.url);
        }

        const args = {
          paged: stateObj.page,
          base: stateObj.base,
          sort: stateObj.sort,
          postType: stateObj.postType,
          exclude: stateObj.exclude,
          taxonomy: stateObj.taxonomy,
          term: stateObj.term,
        };

        if (stateObj.search !== false) {
          args.search = stateObj.search;
        }
        if (stateObj.hasOwnProperty("postsPerPage")) {
          args.postsPerPage = stateObj.postsPerPage;
        }
        if (stateObj.hasOwnProperty("cardArgs")) {
          args.cardArgs = stateObj.cardArgs;
        }
        if (
          stateObj.hasOwnProperty("filters") &&
          Object.keys(stateObj.filters).length
        ) {
          args.filters = stateObj.filters;
        }

        console.log(args);

        $.post(
          archaeologyVars.ajaxURL,
          {
            action: "archaeology_get_archive",
            args: args,
          },
          function (data) {
            console.log(data);
            try {
              const res = JSON.parse(data);
              const state = Flip.getState(
                archiveFeed.get(0).querySelector("li")
              );
              $(archiveFeed).html(res.results);
              $(archivePagination).html(res.pagination);

              Flip.from(state, {
                absolute: true,
                duration: 0.6,
                onEnter: (elements) =>
                  gsap.fromTo(elements, { opacity: 0 }, { opacity: 1 }),
                onLeave: (elements) =>
                  gsap.fromTo(elements, { opacity: 1 }, { opacity: 0 }),
              });
            } catch (err) {
              console.log(err);
            }
          }
        ).always(function () {
          $(archiveBlock).removeClass("loading");
          ajaxIsLoading = false;
        });
      };
    });
  }
  /* END ARCHIVE BLOCK SCRIPTS */

  if ($(".darwin-login").length) {
    $(".darwin-login").each(function () {
      const radios = $(this).find(".darwin-login__lookuptype--input");
      const groups = $(this).find(".darwin-login__group");

      radios.on("change", function () {
        console.log(this);
        if ($(this).is(":checked")) {
          groups.hide();
          groups.filter("." + $(this).attr("value")).show();
        }
      });
    });
  }

  if ($(".email-capture_wrapper").length) {
    $(".email-capture_wrapper").each(function () {
      const formid = $(this).find("form.email-capture").data("formid");
      console.log("form id: " + formid);
      $(document).bind("gform_confirmation_loaded", function (event, form_id) {
        if (form_id === formid) {
          let target =
            $("#gform_confirmation_wrapper_" + formid).offset().top -
            (isMobile ? 72 : 200) -
            56; // sub 148 for whatever the nav height is or some nice looking distance from the top of the page
          console.log("Offset Top (before adjustment):", target);
          let dist = Math.abs($(window).scrollTop() - target);
          $([document.documentElement, document.body]).animate(
            {
              scrollTop: target,
            },
            Math.min(1200, (dist / 1200) * 1000)
          ); // can also just set it without animating
        }
      });
    });
  }
}); // document ready end

/*
 * Window Resize
 ***************************/
$(window).resize(function () {
  windowWidth = $(window).width();
  windowHeight = $(window).height();
  windowScrollHeight = document.querySelector("body").scrollHeight;
  let oldState = isMobile;
  isMobile = windowWidth <= mobileBreakpoint;
  if (windowResizeActions.length > 0) {
    const updated = oldState != isMobile;
    for (var i = 0; i < windowResizeActions.length; i++) {
      windowResizeActions[i](updated);
    }
  }
}); // end window resize functions

/*
 * Window Scroll
 ***************************/
$(window).on("scroll", function () {
  navTrigger = scrollTop;
  scrollTop = $(this).scrollTop();
}); // end window scroll functions

/*
 * Functions
 ***************************/
//  LIGHTBOX GALLERY
$(document).ready(function () {
  if ($(".wp-block-gallery").length) {
    $(".wp-block-gallery").each(function () {
      const gallery = $(this);
      const modal = $(
        '<div class="wp-block-gallery__lightbox" style="visibility: hidden; pointer-events: none;"></div>'
      );
      const modalInner = $(
        '<div class="wp-block-gallery__lightbox-inner slick-slider"></div>'
      ).css("opacity", 0);
      const modalClose = $(
        '<button type="button" class="wp-block-gallery__lightbox-close"></button>'
      );

      modal.append(modalClose, modalInner);
      $("#primary").append(modal);

      gallery.find("img").each(function (index) {
        $(this).on("click", function () {
          modalInner.empty();

          gallery.find("figure").each(function () {
            const clone = $(this).clone();
            const imageCredit = $(this).find("img").data("image-credit");
            if (imageCredit && imageCredit.trim() !== "") {
              if (clone.find("figcaption").length) {
                const creditHtml = $(
                  '<div class="image-credit">' + imageCredit + "</div>"
                );
                clone.find("figcaption").append(creditHtml);
              } else {
                const creditHtml = $(
                  '<figcaption class="wp-element-caption"><div class="image-credit">' +
                    imageCredit +
                    "</div></figcaption>"
                );
                clone.append(creditHtml);
              }
            }

            modalInner.append(clone);
          });

          modal.css({
            visibility: "visible",
            "pointer-events": "auto",
          });

          $("body").addClass("lightbox-open").css("overflow", "hidden");

          gsap.to(modal, { background: "rgba(0,0,0,0.8)", duration: 0.3 });
          gsap.to(modalInner, {
            opacity: 1,
            duration: 0.3,
            ease: "power2.out",
            onComplete: function () {
              modalInner.slick({
                initialSlide: index,
                prevArrow: prevArrow,
                nextArrow: nextArrow,
                appendArrows: modal,
                cssEase: "cubic-bezier(0.4, 0.0, 0.2, 1)",
                speed: 1200,
              });
              gsap.to(modalInner.find("figure, figcaption, .image-credit"), {
                opacity: 1,
                duration: 0.3,
              });
              gsap.to(".slick-big-arrow, .wp-block-gallery__lightbox-close", {
                opacity: 1,
                duration: 0.3,
              });
            },
          });
        });
      });

      modalClose.on("click", closeModal);
      modal.on("click", function (e) {
        if (e.target === modal[0] || e.target === modalClose[0]) {
          closeModal();
        }
      });

      function closeModal() {
        gsap.to(
          [modalInner, ".slick-big-arrow, .wp-block-gallery__lightbox-close"],
          { opacity: 0, duration: 0.6 }
        );
        gsap.to(modal, { background: "rgba(0,0,0,0)", duration: 0.6 });
        $("body").removeClass("lightbox-open").css("overflow", "");

        setTimeout(function () {
          modal.css("visibility", "hidden").css("pointer-events", "none");
          modalInner.slick("unslick");
        }, 600);
      }
    });
  }
});

// AIA GRAPHIC
$(".site-header__aia-graphic").click(function () {
  $(".aia-popup").fadeIn().css("display", "flex");
  $(".site-overlay").fadeIn().css("display", "flex");
  $("body").css("overflow", "hidden");
});

$(".aia-close").click(function () {
  $(".aia-popup").fadeOut();
  $(".site-overlay").fadeOut();
  $("body").css("overflow", "visible");
});

$(document).ready(function () {
  $(".search-close").on("click", function () {
    $(".site-searchform__input").val("");
  });
});

// Photo credit
jQuery(document).ready(function ($) {
  console.log("Image caption credit function");

  const processImages = () => {
    $("figure.wp-block-image img").each(function () {
      const $img = $(this);
      if ($img.closest(".wp-block-gallery, .slick-gallery").length) return;

      // Validate credit existence properly
      const rawCredit = $img.data("image-credit") || "";
      const credit = $("<textarea/>").html(rawCredit).text().trim();

      const $figure = $img.closest(".wp-block-image");
      let $figcaption = $figure.find("figcaption");
      let $staticCredit = $figcaption.find("span.wp-element-credit");

      // Ensure figure element is in DOM before manipulation
      if (!$figure.is(":visible")) {
        console.warn("Parent figure not in DOM", $figure);
        return;
      }

      if ($staticCredit.length) {
        console.log("Static Caption already added");
      } else {
        if ($figcaption.length) {
          // Clean existing empty captions
          if (!$figcaption.text().trim() && !credit) $figcaption.remove();

          const $creditContainer = $figcaption.find(".credit");
          if (!$creditContainer.length) {
            $figcaption.append(
              `<div class="photoCredit"><div class="credit">${credit}</div></div>`
            );
            console.log("Added credit to existing figcaption", $figcaption);
          }
        } else if (credit) {
          // Create full caption structure with visibility checks
          const newFigcaption = $(
            `<figcaption class="wp-element-credit" style="display:block !important">
              <div class="photoCredit"><div class="credit">${credit}</div></div>
            </figcaption>`
          );

          // Verify append operation
          const originalParent = $figure.parent();
          $figure.append(newFigcaption);

          // DOM validation check
          if (!newFigcaption.is(":visible")) {
            console.error("Figcaption not visible after append", {
              figure: $figure,
              styles: window.getComputedStyle(newFigcaption[0]),
            });
          }

          console.log("Created new figcaption", newFigcaption);
        }
      }
    });
  };

  // Initial processing
  processImages();

  // Handle dynamic content
  if (typeof MutationObserver !== "undefined") {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.addedNodes.length) {
          processImages();
        }
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: false,
      characterData: false,
    });
  }
});

// Mobile add - Remove from header & add to footer
$(document).ready(function () {});

// anchor links
if (window.location.hash != "") {
  if ($(window.location.hash).length) {
    document.body.scrollTop = 0;
    setTimeout(function () {
      let target = $(window.location.hash).offset().top - (isMobile ? 72 : 200); // sub 148 for whatever the nav height is or some nice looking distance from the top of the page
      console.log("Offset Top (before adjustment):", target);
      let dist = Math.abs($(window).scrollTop() - target);
      $([document.documentElement, document.body]).animate(
        {
          scrollTop: target,
        },
        Math.min(1200, (dist / 1200) * 1000)
      ); // can also just set it without animating
    }, 300);
  }
}
